import { FC } from 'react';

import ImageContent from './ImageContent';
import LinkContent from './LinkContent';
import TextContent from './TextContent';
import VideoContent from './VideoContent';

const Content: FC<{
  contentType: string;
  content: { url?: string; text?: string; metadata?: any };
}> = ({ contentType, content }) => {
  const Content: any = {
    image: <ImageContent src={content?.url || ''} />,
    video: <VideoContent src={content?.url || ''} />,
    text: <TextContent text={content?.text || ''} />,
    link: <LinkContent link={content?.url || ''} metadata={content?.metadata} />,
    asset: <LinkContent link={content?.url || ''} metadata={content?.metadata} />,
  };

  return Content[contentType];
};

export default Content;
